import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as AttachmentSVG } from "../../images/svg/attachment.svg";
import { FileAttachmentApi } from "../../services/Api/Organization/types";
import { onDownloadAttachment } from "./services/attachment";

interface Props {
	attachments: FileAttachmentApi[];
}

const AttachmentsCard: FC<Props> = ({ attachments }) => {
	const { t } = useTranslation();

	return (
		<Card className="card-box attachments-card">
			<Card.Body>
				<h5 className="card-title">{t("common.word.attachments")}</h5>
				<div className="row px-2">
					{attachments.map((attachment, index) => (
						<div className="attachment-item d-flex align-items-center" key={`attachment-${index}`}>
							<AttachmentSVG className="me-2" />
							<a href="javascript:" onClick={() => onDownloadAttachment(attachment)}>
								{attachment.name}
							</a>
						</div>
					))}
				</div>
			</Card.Body>
		</Card>
	);
};

export default AttachmentsCard;
